export default {
  InventoryItem: 'InventoryItem',
  NonInventoryItem: 'NonInventoryItem',
};
